<template>
  <div id="event-information">
    <call />
    <pop-alert />
    <!-- header -->
    <top-bar title="イベント一覧" backUrl="/" :customClass="customClass"/>
    <!-- main -->
    <main>
      <!-- nav bot -->
      <footer-app page="events"></footer-app>
      <!-- event information -->
      <section :class="{ 'fade-base': true, 'fade': pageFade }">
        <EventList
          :events="eventList"
          :setEventList="setEventList"
          :initialTab="initialTab"
          >
          <div class="c-tab-menu js-swiper_tab">
							<div class="c-tab-menu__wrap">
								<div :class="{ 'swiper-slide': true, 'c-tab-nav__item': true, 'is-active': initialTab == 0 }"
									@click="initialTab = 0">本日のイベント</div>
								<div :class="{ 'swiper-slide': true, 'c-tab-nav__item': true, 'is-active': initialTab == 1 }"
									@click="initialTab = 1">すべてのイベント</div>
							</div>
						</div>
        </EventList>
      </section>
      <loader :loading="loading" />
      <modal_login_required></modal_login_required>
      <alert :message="alert_msg" :show="alert_show" :closeModal="closeModal" :confirm_show="confirm_show"
        :confirm_message="confirm_msg" :confirm_callback="confirm_callback" :confirm_hide_cancel="confirm_hide_cancel"
        :label_cancel="confirm_label_cancel" :label_ok="confirm_label_ok"></alert>
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import Footer from "../components/Footer.vue";
import Alert from "../components/Alert.vue";
import ModalLoginRequired from "../components/ModalLoginRequired.vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import {
  getLocalAllEvents,
  getServerAllEvents
} from "../store/firestore.js";
import { EVENT_COLLECTION_KEY } from "../config/const.js";
import dayjs from "dayjs";
import PopAlert from "../components/PopAlert.vue";
import loader from "../components/parts/loader.vue"
import TopBar from "../components/TopBar.vue";
import EventList from "../components/EventList.vue";

export default Vue.extend({
  name: "Events",
  components: {
    'footer-app': Footer,
    'modal_login_required': ModalLoginRequired,
    'alert': Alert,
    "loader": loader,
    PopAlert,
    TopBar,
    EventList
  },
  mixins: [Tenant],
  data() {
    return {
      attrs: [
        {
          key: 'today',
          highlight: true,
          dates: new Date(),
        }
      ],
      eventAllList: [],
      eventList: [],
      currentDate: Common.getUrlParam('date') || dayjs().format("YYYY-MM-DD"),
      EVENT_COLLECTION_KEY: EVENT_COLLECTION_KEY,
      initialTab: Common.getUrlParam('tab') || 0,
      loading: false,
      isFavorite: false,
      openModal: false,
      shopId: this.SHOP_ID || this.$store.state.shopId,
    }
  },
  async created() {
    this.currentDate = new Date()
    this.getEventAllList();
  },
  computed: {
    customClass() {
      return this.$route.query.from == 'top' ? 'z-hidden' : '';
    }
  },
  mounted() {
    this.$watch('initialTab', () => {
      this.setEventList()
    })
  },
  updated() {
    this.$nextTick(function () {
      Common.setKeepRatio()
    })
  },
  methods: {
    async getEventAllList() {
      this.eventAllList = await getLocalAllEvents()
      this.setEventList()
      setTimeout(async () => {
        this.eventAllList = await getServerAllEvents()
        this.setEventList()
      });
    },
    toggleFavorite() {
      this.isFavorite = !this.isFavorite;
    },
    setEventList() {
      if (this.initialTab == 0) {
        this.eventList = this.eventAllList
          .filter(event => {
            return (event.eventStartAt ? dayjs(event.eventStartAt).isBefore(this.currentDate) : true) && (event.eventEndAt ? dayjs(event.eventEndAt).isAfter(this.currentDate) : true)
          })
      } else {
        this.eventList = this.eventAllList
      }
    },
  }
})
</script>
